<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Configurations</span>
			<more-info-c></more-info-c>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">Incident handling, detection rules and reviewers for account takeover protection</span>
		</div>
	</div>
	<div class="page-inner-content-holder gap-3 pt-0 flex-column" [ngClass]="{'no-scroll' : gs.getTabName() === dic.CONSTANTS.accountCompromisedCfgPageTabs.rules}">
		<!--Tabs-->
		<div class="md-tabs" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}">
			<ng-container *ngFor="let tab of dic.CONSTANTS.accountCompromisedCfgPageTabs | keyvalue: gs.returnZero">
				<div [ngClass]="{'selected' : gs.getTabName() === tab.value}"
					 [routerLink]="tab.value" queryParamsHandling="preserve">
					<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="gs.getTabName() === tab.value">
					<label for="{{tab.key}}Toggle">{{tab.value | camelCaseToTitleCase}}</label>
				</div>
			</ng-container>


			<div class="slide" [ngStyle]="{'left' : tabWidth * _.values(dic.CONSTANTS.accountCompromisedCfgPageTabs).indexOf(gs.getTabName()) + 'px' || 0}"></div>
		</div>
		<!---->

		<router-outlet></router-outlet>
	</div>
</div>
